import { useLang } from '@/i18n';
import EFComputer from 'elem/ui-assets/icons/appliances/EFComputer';
import EFDrone from 'elem/ui-assets/icons/appliances/EFDrone';
import EFNAS from 'elem/ui-assets/icons/appliances/EFNAS';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import EfImg from 'elem/ui/ef-img';
import EfInfoSection from 'elem/ui/ef-info-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useState } from 'react';
import Laptop from '../icons/Laptop';
import Light from '../icons/Light';
import Phone from '../icons/Phone';
import WiFi from '../icons/WiFi';
import { IMG_R3_MAX, IMG_R3_MAX_PLUS, IMG_R3_PLUS, IMG_R3_UPS } from '../utils';
import { useProductStore } from './../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabB');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const [active, setActive] = useState(0);

    const items = [
        {
            title: t('d_title'),
            desc: t('d_desc'),
            tab: t('d_tab'),
            pc: IMG_R3_UPS,
            backupTime: '1.9 Hrs',
            lists: [
                {
                    icon: <EFPhone />,
                    text: t('d_item1'),
                    hour: t('d_item1_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('d_item2'),
                    hour: t('d_item2_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('d_item3'),
                    hour: t('d_item3_hour'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('d_item4'),
                    hour: t('d_item4_hour'),
                },
                {
                    icon: <EFNAS />,
                    text: t('d_item5'),
                    hour: t('d_item5_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('d_item6'),
                    hour: t('d_item6_hour'),
                },
            ],
        },
        {
            title: t('a_title'),
            desc: t('a_desc'),
            tab: t('a_tab'),
            pc: IMG_R3_PLUS,
            backupTime: '2.2 Hrs',
            lists: [
                {
                    icon: <EFPhone />,
                    text: t('a_item1'),
                    hour: t('a_item1_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('a_item2'),
                    hour: t('a_item2_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('a_item3'),
                    hour: t('a_item3_hour'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('a_item4'),
                    hour: t('a_item4_hour'),
                },
                {
                    icon: <EFNAS />,
                    text: t('a_item5'),
                    hour: t('a_item5_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('a_item6'),
                    hour: t('a_item6_hour'),
                },
                {
                    icon: <EFDrone />,
                    text: t('a_item7'),
                    hour: t('a_item7_hour'),
                },
            ],
        },
        {
            title: t('b_title'),
            desc: t('b_desc'),
            tab: t('b_tab'),
            pc: IMG_R3_MAX,
            backupTime: '4.5 Hrs',
            lists: [
                {
                    icon: <EFPhone />,
                    text: t('b_item1'),
                    hour: t('b_item1_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('b_item2'),
                    hour: t('b_item2_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('b_item3'),
                    hour: t('b_item3_hour'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('b_item4'),
                    hour: t('b_item4_hour'),
                },
                {
                    icon: <EFNAS />,
                    text: t('b_item5'),
                    hour: t('b_item5_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('b_item6'),
                    hour: t('b_item6_hour'),
                },
                {
                    icon: <EFDrone />,
                    text: t('b_item7'),
                    hour: t('b_item7_hour'),
                },
            ],
        },
        {
            title: t('c_title'),
            desc: t('c_desc'),
            tab: t('c_tab'),
            pc: IMG_R3_MAX_PLUS,
            backupTime: '6.7 Hrs',
            lists: [
                {
                    icon: <EFPhone />,
                    text: t('c_item1'),
                    hour: t('c_item1_hour'),
                },
                {
                    icon: <EFComputer />,
                    text: t('c_item2'),
                    hour: t('c_item2_hour'),
                },
                {
                    icon: <EFRefrigerator />,
                    text: t('c_item3'),
                    hour: t('c_item3_hour'),
                },
                {
                    icon: <EFWiFi />,
                    text: t('c_item4'),
                    hour: t('c_item4_hour'),
                },
                {
                    icon: <EFNAS />,
                    text: t('c_item5'),
                    hour: t('c_item5_hour'),
                },
                {
                    icon: <EFTV />,
                    text: t('c_item6'),
                    hour: t('c_item6_hour'),
                },
                {
                    icon: <EFDrone />,
                    text: t('c_item7'),
                    hour: t('c_item7_hour'),
                },
            ],
        },
    ];

    const handleChangeTab = (k: number) => {
        setActive(k);
    };

    const appItems = [
        {
            icon: <Phone />,
            text: t('F_item1_app1_text1'),
        },
        {
            icon: <WiFi />,
            text: t('F_item1_app1_text2'),
        },
        {
            icon: <Laptop />,
            text: t('F_item1_app1_text3'),
        },
        {
            icon: <Light />,
            text: t('F_item1_app1_text4'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfInfoSection label={t('title')} title={t('label')} desc={t('desc')} />
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                            <ul className="item-lists">
                                {item?.lists?.map((list: any, m: number) => (
                                    <li className="item-list" key={`${k}_${m}`}>
                                        <div className="list-icon">{list.icon}</div>
                                        <p className="list-text">{list.text}</p>
                                        <p className="list-text list-hour">{list.hour}</p>
                                    </li>
                                ))}
                            </ul>
                            <div className="item-combine-app">
                                <ul className="item-app2 item-apps">
                                    {appItems?.map((app: any, m: number) => (
                                        <li className="item-app" key={`${k}_${m}`}>
                                            <div className="item-app-icon">{app.icon}</div>
                                            <p className="item-app-text">{app.text}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className="border"></div>
                                <div className="total">
                                    <p className="total-sum">{item.backupTime}</p>
                                    <p className="backup">{t('F_backup')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="item-img">
                            <EfImg pc={item.pc} />
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items?.map((item: any, k: number) => (
                    <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                        {item.tab}
                    </li>
                ))}
            </ul>
        </div>
    );
}
